import React from "react";
import { connect } from "react-redux";
import Analysis from "./Analysis";
import { changeAnalysisTab } from "../../modules/results/actions";
import {
  changeStep,
  fetchResult,
  fetchDrivers
} from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";

import {
  printPDFOwn,
  printPDFOwnTa,
  printPDFPeer
} from "../../modules/pdf/actions";
import { sendPeerInvitation } from "../../modules/emails/actions";

function AnalysisContainer(props) {
  const { protocol, hostname, pathname } = window.location;
  const type = window.location.pathname.split("/")[1];
  const id = window.location.pathname.split("/")[3];

  let shareUrl;
  let printPDFOwn;

  switch (type) {
    case "profile":
      shareUrl = `${protocol}/${hostname}${pathname.replace("/results", "")}`;

      printPDFOwn = props.printPDFOwnTa;
      break;
    case "twentyfivesections":
      printPDFOwn = props.printPDFOwnTa;
      break;
    case "twelvesections":
      printPDFOwn = props.printPDFOwnTa;

      break;
    default:
      shareUrl = `${protocol}//${hostname}${pathname.replace("/results", "")}`;
      printPDFOwn = props.printPDFOwn;
  }

  return (
    <Analysis
      {...props}
      type={type}
      id={id}
      shareUrl={shareUrl}
      printPDFOwn={printPDFOwn}
    />
  );
}

function mapStateToProps(state) {
  return {
    drivers: state.results.drivers,
    language: state.preference.language,
    skillChartResult: state.results.result,
    highlight: state.results.highlight,
    loading: state.results.loading,
    peer1Name: state.results.peer1Name,
    peer2Name: state.results.peer2Name,
    peer3Name: state.results.peer3Name,
    owner: state.results.owner,
    step: state.results.step,
    author: state.results.adminResult,
    groupedByCategory: state.results.groupedByCategory
  };
}

const mapActionsToProps = {
  changeAnalysisTab,
  changeStep,
  fetchResult,
  changeLanguage,
  printPDFOwn,
  printPDFOwnTa,
  sendPeerInvitation,
  fetchDrivers,
  printPDFPeer
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(AnalysisContainer);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/AnalysisContainer.js